import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  currency: []
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/properties/index.js